import { AppLayoutHostComponent } from './app-layout-host/app-layout-host.component';
import { LayoutAuthComponent } from './layout-auth/layout-auth.component';
import { LayoutDashboardComponent } from './layout-dashboard/layout-dashboard.component';
import { LayoutErrorComponent } from './layout-error/layout-error.component';
import { LayoutLeaseManagementComponent } from './layout-lease-management/layout-lease-management.component';
import { LayoutInvoiceManagementComponent } from './layout-invoice-management/layout-invoice-management.component';
import { LayoutUserSimpleComponent } from './layout-user-simple/layout-user-simple.component';
import { DocUploaderLayoutComponent } from './doc-uploader/doc-uploader-layout.component';

export const layouts = [
    AppLayoutHostComponent,
    LayoutDashboardComponent,
    LayoutAuthComponent,
    LayoutErrorComponent,
    LayoutLeaseManagementComponent,
    LayoutInvoiceManagementComponent,
    LayoutUserSimpleComponent,
    DocUploaderLayoutComponent,
];

export * from './app-layout-host/app-layout-host.component';
export * from './layout-dashboard/layout-dashboard.component';
export * from './layout-auth/layout-auth.component';
export * from './layout-error/layout-error.component';
export * from './layout-lease-management/layout-lease-management.component';
export * from './layout-invoice-management/layout-invoice-management.component';
export * from './layout-user-simple/layout-user-simple.component';
export * from './doc-uploader/doc-uploader-layout.component';
